// Load plugins
import helper from "./helper";
import axios from "axios";
import * as Popper from "@popperjs/core";
import dom from "@left4code/tw-starter/dist/js/dom";
import tippy, { roundArrow } from "tippy.js";






// import { Calendar } from "@fullcalendar/core";
// import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import listPlugin from "@fullcalendar/list";



// Set plugins globally
window.helper = helper;
window.axios = axios;
//window.Chart = Chart;
window.Popper = Popper;
window.Tippy = tippy;
window.roundArrow = roundArrow;
// window.Calendar = Calendar;
// window.interactionPlugin = interactionPlugin;
// window.Draggable = Draggable;
// window.dayGridPlugin = dayGridPlugin;
// window.timeGridPlugin = timeGridPlugin;
// window.listPlugin = listPlugin;
window.$ = dom;

// CSRF token
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}
